import { render, staticRenderFns } from "./UtilTagAuction.vue?vue&type=template&id=17d4ef16&scoped=true"
import script from "./UtilTagAuction.vue?vue&type=script&lang=js"
export * from "./UtilTagAuction.vue?vue&type=script&lang=js"
import style0 from "./UtilTagAuction.vue?vue&type=style&index=0&id=17d4ef16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d4ef16",
  null
  
)

export default component.exports